export default {

  namespaced: true,

  state: () => ({


  }),

  mutations: {


  },

  actions: {

    async getUser({ dispatch, commit }, id) {

      const data = await axios.get("/erp/user/user/" + id)
      return data.data

    },
  }
}
